import api from '@e74/services/ApiConfig';
import {fetchStart, fetchSuccess, fetchError, hideMessage} from '../Common';
export const ACTION_TYPES = {
  CREATE: 'CREATE_BODY_LOCATION',
  UPDATE: 'UPDATE_BODY_LOCATION',
  DELETE: 'DELETE_BODY_LOCATION',
  FETCH_ALL: 'FETCH_ALL_BODY_LOCATIONS',
  FETCH_BY_ID: 'FETCH_BODY_LOCATION_BY_ID',
};

export const fetchAll = () => (dispatch) => {
  dispatch(fetchStart());
  api
    .bodylocation()
    .fetchAll()
    .then((response) => {
      dispatch({
        type: ACTION_TYPES.FETCH_ALL,
        payload: response.data,
      });
      dispatch(fetchSuccess());
      dispatch(hideMessage());
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};

export const create = (data, onSuccess) => (dispatch) => {
  dispatch(fetchStart());
  api
    .bodylocation()
    .create(data)
    .then((res) => {
      dispatch({
        type: ACTION_TYPES.CREATE,
        payload: res.data,
      });
      dispatch(fetchSuccess());
      onSuccess();
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};

export const update = (id, data, onSuccess) => (dispatch) => {
  dispatch(fetchStart());
  api
    .bodylocation()
    .update(id, data)
    .then((res) => {
      dispatch({
        type: ACTION_TYPES.UPDATE,
        payload: {id, ...data},
      });
      dispatch(fetchSuccess());
      onSuccess();
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};

export const Delete = (id) => (dispatch) => {
  dispatch(fetchStart());
  api
    .bodylocation()
    .delete(id)
    .then((res) => {
      dispatch({
        type: ACTION_TYPES.DELETE,
        payload: id,
      });
      dispatch(fetchSuccess());
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};

export const fetchById = (id) => (dispatch) => {
  dispatch(fetchStart());
  api
    .bodylocation()
    .fetchById(id)
    .then((res) => {
      dispatch({
        type: ACTION_TYPES.DELETE,
        payload: res.data,
      });
      dispatch(fetchSuccess());
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};
